import ClientsAxios from '../client-axios';
import { ForgotPasswordRequest, LoginRequest, ResetPasswordRequest, ValidateCompanyCodeRequest } from '../dto/request';
import { LoginResponse, ResponseEntity, ValidateCompanyCodeResponse } from '../dto/response';
import { UserRoleDetailsResponse } from '../dto/response/user/user';

const { API_SERVER } = ClientsAxios;


export const loginService = async (payload: LoginRequest) => {
    const responseEntity = new ResponseEntity<LoginResponse>()
    try {
        const response = await API_SERVER.post('user/login', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const FetchRoleListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('roles/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchUserRoleDetailsService = async (payload: {}) => {
    const responseEntity = new ResponseEntity<UserRoleDetailsResponse>();
    try {
        const response = await API_SERVER.post(`user-role-permissions`, payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const ForgotPasswordService = async (payload: ForgotPasswordRequest) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('user/forgot-password', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const ResetPasswordService = async (payload: ResetPasswordRequest) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('user/reset-password', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const ValidateCompanyCodeService = async (payload: ValidateCompanyCodeRequest) => {
    const responseEntity = new ResponseEntity<ValidateCompanyCodeResponse>()
    try {
        const response = await API_SERVER.post('company/get-name', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

